import type { SearchResponse } from "src/api/SearchResponse";
import { SegmentCarHirePromoDriveVariant } from "src/domain/SegmentScreen/SegmentCarHirePromoDriveVariant/SegmentCarHirePromoDriveVariant";
import styled from "styled-components";
import { tw } from "src/design-system/tw";
import { useFeature } from "src/feature/useFeature";
import {
  color,
  fontSize,
  fontWeight,
  screenMinWidth,
  spacing,
} from "../../../../theme";
import { Timeline } from "../../Timeline";
import type { OriginCell } from "../cell/OriginCell";

type ConditionalDriveSegmentProps =
  | {
      isDriveSegment: boolean;
      segmentIndex: number;
      searchResponse: SearchResponse;
    }
  | {
      isDriveSegment?: false;
      segmentIndex?: never;
      searchResponse?: never;
    };

type Props = {
  cell: OriginCell;
  className?: string;
} & ConditionalDriveSegmentProps;

export function TroniconTimelineOrigin(props: Props) {
  const isHotelPromoDriveSegment = useFeature("HotelPromoDriveSegment");

  return (
    <div
      className={tw(
        "mt-1.5 flex min-h-9 items-center pl-4 md:items-center",
        props.isDriveSegment && "items-start",
        props.className,
      )}
    >
      <Timeline type="origin" transitMode={props.cell.transitMode} />
      <Content>
        <LeftAligned>
          <OriginName
            shouldBold={props.cell.isFirstSegment || props.cell.isStandalone}
          >
            {props.cell.placeName}
          </OriginName>
          {props.cell.tripOriginName && (
            <AlternativeOriginName>
              {props.cell.tripOriginName}
            </AlternativeOriginName>
          )}
        </LeftAligned>
        {props.isDriveSegment && !isHotelPromoDriveSegment && (
          <SegmentCarHirePromoDriveVariant
            location={props.cell.placeName}
            segmentIndex={props.segmentIndex}
            searchResponse={props.searchResponse}
            transitMode={props.cell.transitMode}
          />
        )}
      </Content>
    </div>
  );
}

const Content = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  gap: ${spacing.md};
  padding: 0 ${spacing.xl};
  ${screenMinWidth.md} {
    flex-direction: row;
  }
`;

const LeftAligned = styled.span`
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-right: auto;
`;

const OriginName = styled.span<{ shouldBold: boolean }>`
  font-size: ${fontSize.h5};
  font-weight: ${(props) =>
    props.shouldBold ? fontWeight.medium : fontWeight.normal};
`;

const AlternativeOriginName = styled.span`
  font-size: ${fontSize.h6};
  color: ${color.n90};
`;
